import React from "react";
import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import {
  format,
  parse,
  startOfWeek,
  getDay,
  startOfToday,
  isSameMonth,
} from "date-fns";
import "react-big-calendar/lib/css/react-big-calendar.css";
import CustomEvent from "./Events";
import { Box, darken, Typography, useTheme } from "@mui/material";

const locales = {
  "en-US": require("date-fns/locale/en-US"),
};

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek: () => startOfWeek(new Date(), { weekStartsOn: 0 }),
  getDay,
  locales,
});

const CentralCalendarComponent = ({ data, onSelectEvent, title }) => {
  const events = data || [];
  const theme = useTheme();

  const eventStyleGetter = (event) => {
    let style = {
      borderRadius: "8px",
      color: "#000",
      fontWeight: 500,
      fontSize: "0.8rem",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      backgroundColor: event?.colorCode || theme?.palette?.primary?.main,
      border: `2px solid ${
        darken(event?.colorCode, 0.2) || theme?.palette?.primary?.main
      }`,
    };

    return {
      className: "custom-event",
      style: style,
      title: "",
    };
  };

  const CustomToolbar = (toolbar) => {
    const goToBack = () => toolbar.onNavigate("PREV");
    const goToNext = () => toolbar.onNavigate("NEXT");
    const goToToday = () => toolbar.onNavigate("TODAY");
    const label = format(toolbar.date, "MMMM yyyy");
    const today = startOfToday();
    const isCurrentMonth = isSameMonth(toolbar.date, today);

    return (
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        p={2}
        bgcolor={"primary.moonGlow"}
      >
        <Typography variant="h5" fontWeight={600} color={"secondary.light"}>
          {title} {label}
        </Typography>
        <Box display="flex" gap={1}>
          {!isCurrentMonth && <button onClick={goToToday}>Current</button>}
          <button onClick={goToBack}>◀</button>
          <button onClick={goToNext}>▶</button>
        </Box>
      </Box>
    );
  };

  const dayPropGetter = (date) => {
    const isSaturday = date.getDay() === 6;
    const isSunday = date.getDay() === 0;

    let style = {};
    let title = "";

    if (isSaturday || isSunday) {
      style.backgroundColor = "#e3f2fd"; // Light blue for weekends
      title = isSaturday ? "Saturday" : "Sunday";
    }

    return {
      style,
      title,
    };
  };

  return (
    <Box
      height={"80vh"}
      border={"1px solid black"}
      borderColor={"primary.main"}
    >
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        views={["month"]}
        defaultView="month"
        tooltipAccessor={() => null}
        popup={true}
        selectable={false}
        onSelectEvent={onSelectEvent}
        draggableAccessor={() => false}
        resizable={false}
        style={{
          height: "100%",
          backgroundColor: "#f9fafb",
          borderRadius: "12px",
        }}
        eventPropGetter={eventStyleGetter}
        dayPropGetter={dayPropGetter}
        components={{
          event: CustomEvent,
          toolbar: CustomToolbar,
        }}
      />
    </Box>
  );
};

export default CentralCalendarComponent;
